/**
 * TanStack Query hooks for `igaming-approval-workflows-for-payouts`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingApprovalWorkflowsForPayoutsQueryKeys,
	type CreateIgamingApprovalWorkflowsForPayoutsBody,
	type ListIgamingApprovalWorkflowsForPayoutsResponse,
	type IgamingApprovalWorkflowsForPayoutsRow,
} from "./api";

export function useIgamingApprovalWorkflowsForPayoutsList(): UseQueryResult<ListIgamingApprovalWorkflowsForPayoutsResponse, Error> {
	return useQuery({
		queryKey: igamingApprovalWorkflowsForPayoutsQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingApprovalWorkflowsForPayoutsCreate(): UseMutationResult<IgamingApprovalWorkflowsForPayoutsRow, Error, CreateIgamingApprovalWorkflowsForPayoutsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingApprovalWorkflowsForPayoutsQueryKeys.all });
		},
	});
}

export function useIgamingApprovalWorkflowsForPayoutsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingApprovalWorkflowsForPayoutsQueryKeys.all });
		},
	});
}
